import { profileActionTypes } from './profile.types';
import { logOut } from '../user/user.actions';

import http from '../../services/http';

export const selectProfiles = state => state.profile.profiles;
export const selectAvailablePermissions = state => state.profile.availablePermissions;

const setProfiles = profiles => {
    return {
        type: profileActionTypes.SET_PROFILES,
        payload: profiles
    };
};

const setAvailablePermissions = permissions => {
    return {
        type: profileActionTypes.SET_AVAILABLE_PERMISSIONS,
        payload: permissions
    };
};

export const updateProfile = (profile) => {
    return async dispatch => {
        try {
            await http.put(`/profiles/${profile.id}`, profile);
            dispatch(getProfiles());
        } catch (error) {
            if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                dispatch(logOut());
            } else {
                console.log(error);
            }
        }
    };
};

export const getProfiles = (withPermissions = false) => {
    return async dispatch => {
        try {
            const url = withPermissions ? '/profiles?with_permissions=1' : '/profiles';
            const response = await http.get(url);
            dispatch(setProfiles(response.data));
        } catch (error) {
            if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                dispatch(logOut());
            } else {
                console.log(error);
            }
        }
    };
};

export const getAvailablePermissions = () => {
    return async dispatch => {
        try {
            const response = await http.get('/permissions/available');
            dispatch(setAvailablePermissions(response.data));
        } catch (error) {
            if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                dispatch(logOut());
            } else {
                console.log(error);
            }
        }
    };
};

export const updateProfilePermissions = (profileId, permissions) => {
    return async dispatch => {
        try {
            await http.put(`/profiles/${profileId}/permissions`, { permissions });
            dispatch(getProfiles(true));
        } catch (error) {
            if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                dispatch(logOut());
            } else {
                console.log(error);
            }
        }
    };
};

/** Cria um perfil (entidade de permissões). Apenas quem tem permissão ou é admin/líder/super admin. */
export const createProfile = (data) => {
    return async dispatch => {
        try {
            await http.post('/profiles', data);
            dispatch(getProfiles(true));
        } catch (error) {
            if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                dispatch(logOut());
            } else {
                throw error;
            }
        }
    };
};

/** Atualiza um perfil (nome, etc). Apenas quem tem permissão ou é admin/líder/super admin. */
export const updateProfileEntity = (profile) => {
    return async dispatch => {
        try {
            await http.put(`/profiles/${profile.id}`, {
                name: profile.name,
                picture: profile.picture,
                status: profile.status,
            });
            dispatch(getProfiles(true));
        } catch (error) {
            if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                dispatch(logOut());
            } else {
                throw error;
            }
        }
    };
};

/** Exclui um perfil. Apenas quem tem permissão ou é admin/líder/super admin. */
export const deleteProfile = (id) => {
    return async dispatch => {
        try {
            await http.delete(`/profiles/${id}`);
            dispatch(getProfiles(true));
        } catch (error) {
            if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                dispatch(logOut());
            } else {
                throw error;
            }
        }
    };
};